import { Navigate, Outlet } from "react-router";
import { useAuthUser } from "@/features/auth/AuthContext";

interface Props {
  isPublic?: boolean;
}

const ProtectedRoute = ({ isPublic = false }: Props) => {
  const { isAuthenticated, isLoading } = useAuthUser();

  if (isLoading) return null;

  if (!isPublic && !isAuthenticated) {
    sessionStorage.setItem(
      "returnUrl",
      window.location.pathname + window.location.search + window.location.hash,
    );
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
